import { Component, OnInit, Input, ViewChild, EventEmitter, Output, ViewChildren, ViewEncapsulation, TemplateRef } from '@angular/core';
import 'jquery'; import { Observable, interval, Subscription } from 'rxjs';
declare var $: any;
import '@progress/kendo-ui';
declare var kendo: any;
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaNotepadService } from '../../services/epbt-fa-notepad.service';
import { EpbtFaCalendarService } from '../../services/epbt-fa-calendar.service';
import { WebTrackUser, BisTrackSettings, GetCustomerNotepadItemsRequest, CustomerNotepad } from 'ep-bt-field-agent-proxy';
import { SchedulerEvent, Resource } from '@progress/kendo-angular-scheduler';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-calendar',
  templateUrl: './epbt-fa-calendar.component.html',
  styleUrls: ['./epbt-fa-calendar.component.scss']
})
export class EpbtFaCalendarComponent implements OnInit {

  scheduler: any;
  bisTrackSettings: BisTrackSettings;
  webTrackUser: WebTrackUser;
  resourceData: any[] = [];
  eventData: any[];

  constructor(private faService: EpbtFieldAgentService, private notepadService: EpbtFaNotepadService, private calendarService: EpbtFaCalendarService) {
    this.eventData = [];
  }


  baseData: any[] = [
    {
      'TaskID': 4,
      'OwnerID': 2,
      'Title': 'Bowling tournament',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-09T21:00:00.000Z',
      'End': '2013-06-10T00:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 5,
      'OwnerID': 2,
      'Title': 'Take the dog to the vet',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-10T07:00:00.000Z',
      'End': '2013-06-10T08:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 6,
      'OwnerID': 2,
      'Title': 'Call Charlie about the project',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-11T11:30:00.000Z',
      'End': '2013-06-11T13:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 7,
      'OwnerID': 3,
      'Title': 'Meeting with Alex',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-12T11:00:00.000Z',
      'End': '2013-06-12T12:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 9,
      'OwnerID': 2,
      'Title': "Alex's Birthday",
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-14T02:00:00.000Z',
      'End': '2013-06-14T02:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': true
    },
    {
      'TaskID': 12,
      'OwnerID': 2,
      'Title': 'Car Service',
      'Description': 'Might come to work later!',
      'StartTimezone': null,
      'Start': '2013-06-24T08:30:00.000Z',
      'End': '2013-06-24T09:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 14,
      'OwnerID': 3,
      'RoomID': 2,
      'Title': 'Replace the printer on the 1st floor',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-24T10:00:00.000Z',
      'End': '2013-06-24T11:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 15,
      'OwnerID': 1,
      'Title': 'Attending HR Conference',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-25T00:00:00.000Z',
      'End': '2013-06-26T00:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': true
    },
    {
      'TaskID': 16,
      'OwnerID': 1,
      'Title': 'Business Lunch with Gregory Watkins',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-25T12:00:00.000Z',
      'End': '2013-06-25T13:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 17,
      'OwnerID': 1,
      'Title': 'Breakfast with CFO and COO',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-27T08:30:00.000Z',
      'End': '2013-06-27T09:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 18,
      'OwnerID': 1,
      'Title': 'Job Interview - Mathew Stevens',
      'Description': 'Junior Researcher',
      'StartTimezone': null,
      'Start': '2013-06-27T10:00:00.000Z',
      'End': '2013-06-27T11:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 19,
      'OwnerID': 1,
      'Title': 'Review CVs with Tim',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-27T11:00:00.000Z',
      'End': '2013-06-27T11:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 20,
      'OwnerID': 1,
      'Title': 'Lunch with Monica',
      'Description': 'Discuss the Employee handbook',
      'StartTimezone': null,
      'Start': '2013-06-27T12:00:00.000Z',
      'End': '2013-06-27T13:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 21,
      'OwnerID': 1,
      'Title': 'Job Interview - John Stewart',
      'Description': 'Accountant',
      'StartTimezone': null,
      'Start': '2013-06-27T14:00:00.000Z',
      'End': '2013-06-27T15:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 22,
      'OwnerID': 1,
      'Title': 'Job Interview - Mary Smith',
      'Description': 'Accountant',
      'StartTimezone': null,
      'Start': '2013-06-27T15:30:00.000Z',
      'End': '2013-06-27T16:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 24,
      'OwnerID': 3,
      'Title': 'Register new Access Cards',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-24T12:00:00.000Z',
      'End': '2013-06-24T12:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 25,
      'OwnerID': 1,
      'Title': 'HR Lecture',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-04T19:00:00.000Z',
      'End': '2013-06-04T21:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': 'FREQ=WEEKLY;BYDAY=TU,TH',
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 26,
      'OwnerID': 1,
      'Title': 'Dentist',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-28T08:00:00.000Z',
      'End': '2013-06-28T09:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 27,
      'OwnerID': 1,
      'Title': 'Job Interview - Laura Bailey',
      'Description': 'Helpdesk',
      'StartTimezone': null,
      'Start': '2013-06-28T09:30:00.000Z',
      'End': '2013-06-28T10:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 28,
      'OwnerID': 1,
      'Title': 'Job Interview - Jenny Baxter',
      'Description': 'Helpdesk',
      'StartTimezone': null,
      'Start': '2013-06-28T11:00:00.000Z',
      'End': '2013-06-28T12:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 31,
      'OwnerID': 1,
      'Title': 'Team building prep tasks',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-28T14:00:00.000Z',
      'End': '2013-06-28T17:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 32,
      'OwnerID': 1,
      'Title': 'Job Interview - Bernard Atkins',
      'Description': 'Helpdesk',
      'StartTimezone': null,
      'Start': '2013-06-24T13:30:00.000Z',
      'End': '2013-06-24T14:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 34,
      'OwnerID': 1,
      'Title': 'Review Job Applications',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-24T15:00:00.000Z',
      'End': '2013-06-24T17:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 35,
      'OwnerID': 1,
      'Title': 'Grand Canyon tour',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-23T00:00:00.000Z',
      'End': '2013-06-23T00:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': true
    },
    {
      'TaskID': 40,
      'OwnerID': 3,
      'Title': 'Install new laptops in conference rooms',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-24T13:30:00.000Z',
      'End': '2013-06-24T18:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 66,
      'OwnerID': 3,
      'Title': "Bob's Birthday",
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-29T08:00:00.000Z',
      'End': '2013-06-29T06:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': true
    },
    {
      'TaskID': 68,
      'OwnerID': 1,
      'RoomID': 2,
      'Title': 'Breakfast with Tom',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-24T08:30:00.000Z',
      'End': '2013-06-24T09:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 69,
      'OwnerID': 2,
      'Title': 'Team planning meeting',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-24T10:00:00.000Z',
      'End': '2013-06-24T12:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 70,
      'OwnerID': 2,
      'Title': 'Support Phone Call',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-24T16:00:00.000Z',
      'End': '2013-06-24T16:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 71,
      'OwnerID': 2,
      'Title': 'Business breakfast with Caroline',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-25T09:00:00.000Z',
      'End': '2013-06-25T10:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 72,
      'OwnerID': 2,
      'Title': "Discuss preojects' deadlines",
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-25T11:00:00.000Z',
      'End': '2013-06-25T11:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 73,
      'OwnerID': 2,
      'Title': 'Support Meeting',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-25T15:00:00.000Z',
      'End': '2013-06-25T16:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 74,
      'OwnerID': 2,
      'Title': 'Dine with Mathew',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-25T18:30:00.000Z',
      'End': '2013-06-25T20:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 79,
      'OwnerID': 2,
      'Title': 'Banking',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-26T09:00:00.000Z',
      'End': '2013-06-26T10:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 80,
      'OwnerID': 3,
      'Title': 'Software updates',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-25T10:00:00.000Z',
      'End': '2013-06-25T12:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 81,
      'OwnerID': 3,
      'Title': 'UPS maintenance',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-25T16:30:00.000Z',
      'End': '2013-06-25T18:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 82,
      'OwnerID': 2,
      'Title': 'Support Call',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-26T11:30:00.000Z',
      'End': '2013-06-26T12:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 83,
      'OwnerID': 3,
      'Title': 'Phone Sync with NY office ',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-26T13:30:00.000Z',
      'End': '2013-06-26T14:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 84,
      'OwnerID': 3,
      'Title': 'Phone Sync with Boston Office',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-26T15:00:00.000Z',
      'End': '2013-06-26T16:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 85,
      'OwnerID': 3,
      'Title': 'Server maintenance',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-26T18:30:00.000Z',
      'End': '2013-06-26T21:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 86,
      'OwnerID': 2,
      'Title': 'Status meeting',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-28T13:30:00.000Z',
      'End': '2013-06-28T15:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 87,
      'OwnerID': 3,
      'Title': 'Helpdesk status meeting',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-27T10:30:00.000Z',
      'End': '2013-06-27T11:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 88,
      'OwnerID': 2,
      'Title': 'Business Lunch',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-27T12:00:00.000Z',
      'End': '2013-06-27T13:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 89,
      'OwnerID': 3,
      'Title': 'Employee database update',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-27T14:00:00.000Z',
      'End': '2013-06-27T15:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 90,
      'OwnerID': 3,
      'Title': 'Website upload',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-27T07:30:00.000Z',
      'End': '2013-06-27T08:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 91,
      'OwnerID': 2,
      'Title': 'Meeting with marketing guys',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-27T17:00:00.000Z',
      'End': '2013-06-27T18:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 92,
      'OwnerID': 3,
      'Title': 'Meeting with Internet provider',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-28T10:30:00.000Z',
      'End': '2013-06-28T11:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 93,
      'OwnerID': 3,
      'Title': "Bob's Birthday Party",
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-29T20:00:00.000Z',
      'End': '2013-06-29T23:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': null,
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 95,
      'OwnerID': 2,
      'Title': 'Dance Practice',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-03T18:30:00.000Z',
      'End': '2013-06-03T20:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': 'FREQ=WEEKLY;BYDAY=MO,WE',
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 114,
      'OwnerID': 3,
      'Title': 'Software updates',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-04T09:00:00.000Z',
      'End': '2013-06-04T12:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': '',
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 115,
      'OwnerID': 1,
      'Title': 'Breakfast at Starbucks',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-04T08:00:00.000Z',
      'End': '2013-06-04T09:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': '',
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 116,
      'OwnerID': 2,
      'Title': 'Performance review',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-04T14:00:00.000Z',
      'End': '2013-06-04T17:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': '',
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 118,
      'OwnerID': 1,
      'Title': 'HR seminar preparation',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-05T10:00:00.000Z',
      'End': '2013-06-05T12:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': '',
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 119,
      'OwnerID': 3,
      'Title': 'Helpdesk weekly meeting',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-05T15:00:00.000Z',
      'End': '2013-06-05T16:00:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': 'FREQ=WEEKLY;BYDAY=WE',
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    },
    {
      'TaskID': 120,
      'OwnerID': 3,
      'Title': 'Website upload',
      'Description': '',
      'StartTimezone': null,
      'Start': '2013-06-07T07:00:00.000Z',
      'End': '2013-06-07T08:30:00.000Z',
      'EndTimezone': null,
      'RecurrenceRule': '',
      'RecurrenceID': null,
      'RecurrenceException': null,
      'IsAllDay': false
    }
  ];

  currentYear = new Date().getFullYear();


  sampleData = this.baseData.map(dataItem => (
    {
      id: dataItem.TaskID,
      start: this.parseAdjust(dataItem.Start),
      startTimezone: dataItem.startTimezone,
      end: this.parseAdjust(dataItem.End),
      endTimezone: dataItem.endTimezone,
      isAllDay: dataItem.IsAllDay,
      title: dataItem.Title,
      description: dataItem.Description,
      recurrenceRule: dataItem.RecurrenceRule,
      recurrenceId: dataItem.RecurrenceID,
      recurrenceException: dataItem.RecurrenceException,

      roomId: dataItem.RoomID,
      ownerID: dataItem.OwnerID
    }
  ));

  public events: SchedulerEvent[];

  public resources: Resource[] = [{
    name: 'Rooms',
    data: [
      { text: 'Meeting Room 101', value: 1, color: '#6eb3fa' },
      { text: 'Meeting Room 201', value: 2, color: '#f58a8a' }
    ],
    field: 'roomId',
    valueField: 'value',
    textField: 'text',
    colorField: 'color'
  }];

  selectedDate = new Date();

  parseAdjust = (eventDate: string): Date => {
    const date = new Date(eventDate);
    date.setFullYear(this.currentYear);
    return date;
  }

  ngOnInit(): void {

    this.faService.getBisTrackSetting((bisTrackSettings: any) => {
      this.bisTrackSettings = bisTrackSettings;
    });
    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.getNotepadsData();
    });

    // $("#scheduler").on("dblclick", ".k-event", (e) => {
    //   var scheduler = $("#scheduler").getKendoScheduler();
    //   var data = scheduler.occurrenceByUid($(e.currentTarget).data("uid"));
    //   // var journeyId = data && data.currentJourney ? data.currentJourney.journeyId : 0;
    //   // this.route.navigate(['/home/openjourney', journeyId]);
    // });

    // this.GetVehicles();
    // this.getJourneyPlannerSytemOps();
    // setTimeout(() => {
    this.initSchedular();
    console.log(this.scheduler);
    //   // $("#menu").kendoContextMenu({
    //   //   target: "#scheduler",
    //   //   // filter: ".product",
    //   //   animation: {
    //   //     open: { effects: "fadeIn" },
    //   //     duration: 500
    //   //   },
    //   //   select: function (e) {
    //   //     // Do something on select
    //   //   }
    //   // });

    // }, 100);
    // // kendo.ui.progress(this.scheduler.element.find(".k-scheduler-content"), false);
    // var dataSource = new kendo.data.SchedulerDataSource({
    //   data: this.resources
    // });
    // this.scheduler.setDataSource(dataSource);
    // kendo.ui.progress(this.scheduler.element.find(".k-scheduler-content"), true);
  }

  initSchedular() {
    this.scheduler = $('#scheduler').kendoScheduler({
      date: new Date(new Date()),
      // date: new Date(this.selectedDate),
      // allDaySlot: false,
      // footer: true,
      // editable: false,
      showWorkHours: true,
      // eventTemplate:
      //   kendo.template(`<div style='height:500px;background-color:#= background #'><div title='#:body#'   class='event-header'>  #=subject#   </div>
      //   <div class='event-body'> #= body #</div></div>`),
      views: <any>['day', 'week', 'month', 'timeline', 'agenda'],
      dataBound: (e) => {
        // create drop area from current View
        // this.createDropArea(this.scheduler);
      },
      navigate: (e) => {
        // kendo.ui.progress(this.scheduler.element.find('.k-scheduler-content'), true);
        //   if(e.view == 'week' || 'month'){
        //  this.getJourneyPlans(this.scheduler.view().startDate(),this.scheduler.view().endDate());
        // }else{
        setTimeout(() => {
          // this.selectedDate = this.scheduler.view().startDate();
          // this.selectedDateChange.emit(this.selectedDate);
          // this.getJourneyPlans();
          // this.getNotepadsData();
        }, 1000);
        // }
      },
      dataSource: [
        // this.getNotepadsData()
      ],
      resize: () => {

      },
      resizeEnd: (e) => {
        // this.moveSchedulerEvent(e);
      },
      moveEnd: (e) => {
        // this.moveSchedulerEvent(e);
      },
      group: {
        resources: ['vehicle'],
        orientation: 'vertical',
        date: true
      },

      resources: [
        {
          field: 'uniqueId',
          title: 'Notepads',
          name: 'notepads',
          dataSource: []
        }
      ]
    }).data('kendoScheduler');

    // this.getHeight();

    if (this.scheduler) {
      $(window).resize(() => {
        this.getHeight();
      });

      $('#scheduler').on('dblclick', '.k-event', (e) => {
        const scheduler = $('#scheduler').getKendoScheduler();
        const data = scheduler.occurrenceByUid($(e.currentTarget).data('uid'));
        const journeyId = data && data.currentJourney ? data.currentJourney.journeyId : 0;
        // this.route.navigate(['/home/openjourney', journeyId]);
      });


    }

  }

  createDropArea(scheduler: any) {
    scheduler.view().content.kendoDropTargetArea({
      filter: '.k-scheduler-table td, .k-event',
      drop: (e) => {
        const offset = $(e.dropTarget).offset();
        const slot = scheduler.slotByPosition(offset.left, offset.top);
        const resoucres = scheduler.resourcesBySlot(slot);

        // var currentVehicleDetails = this.resourceData.filter(i => i.uniqueId == resoucres.uniqueId);
        // var vehicle: ScheduleVehicleParams = new ScheduleVehicleParams();

        // if (currentVehicleDetails && currentVehicleDetails.length > 0) {
        //   vehicle.driverId = currentVehicleDetails[0].eventDetails.driverId;
        //   vehicle.vehicleId = currentVehicleDetails[0].eventDetails.vehicleId;
        //   vehicle.trailerId = currentVehicleDetails[0].eventDetails.trailervehicleId;
        //   vehicle.trailerTypeId = currentVehicleDetails[0].eventDetails.trailerTypeId;
        //   vehicle.truckId = 0;
        //   vehicle.branchIds = this.dataExService.get('jp.currentBranchId') + '',
        //     vehicle.vehicleTypeId = currentVehicleDetails[0].eventDetails.vehicleId;
        //   vehicle.userID = this.config.getLoggedinUser();
        // }

        // let request: ScheduleEventParams = new ScheduleEventParams();
        // request.scheduleVehicleParams = vehicle;
        // request.branchIds = this.dataExService.get('jp.currentBranchId') + '';
        // request.reference = '';
        // request.stockLocationId = this.dataExService.get('jp.currentStocklocationId') ? this.dataExService.get('jp.currentStocklocationId') : 0;
        // request.userId = this.config.getLoggedinUser();
        // request.addDocumentOption = ScheduleEventParamsAddDocumentOption.VIA_BRANCH;
        // request.addToExistingJourney = ScheduleEventParamsAddToExistingJourney.NONE;

        // if (slot.startDate.getHours() == slot.endDate.getHours() && slot.startDate.getMinutes() == slot.endDate.getMinutes()) {
        //   var endinterval = this.jpConfig.JpOptions && this.jpConfig.JpOptions.timeIntervalForCalendarView ? this.jpConfig.JpOptions.timeIntervalForCalendarView : 30;
        //   slot.endDate.setMinutes(slot.endDate.getMinutes() + endinterval)
        // }

        // var isOverLap = this.scheduler.occurrencesInRange(slot.startDate, slot.endDate);

        // request.fromDate = this.getLocalTime(slot.startDate);
        // request.tillDate = this.getLocalTime(slot.endDate);

        // if (isOverLap && isOverLap.length > 0) {
        //   request.addToExistingJourney = ScheduleEventParamsAddToExistingJourney.TRUE;
        //   request.journeyId = isOverLap[0].currentJourney.journeyId;
        // }

        // if (e.draggable && e.draggable.currentTarget && e.draggable.currentTarget.data() && e.draggable.currentTarget.data().event) {
        //   request.documentId = e.draggable.currentTarget.data().event.documentId;
        //   request.documentNumber = e.draggable.currentTarget.data().event.documentNumber;
        //   request.documentType = e.draggable.currentTarget.data().event.documentTypeId;

        //   if (e.draggable.currentTarget.data().event.isSchedule)
        //     kendo.ui.progress($('#scheduler'), true);
        //   this.scheduleEventPost(request, null, e);
        // }
        this.getNotepadsData();

      }
    }
      // }
    );
  }

  getHeight() {
    const width = $('body').width();
    const widget1 = $('#scheduler').data('kendoScheduler');
    const height = $(window).outerHeight() - 200;
    widget1.element.height(height / 2 - 30);
    widget1.resize(true);

  }

  getNotepadsData() {
    this.notepadService.getCustomerNotepadItems(this.prepareNotepadRequest(), (notepadsResponseResult) => {
      if (notepadsResponseResult && notepadsResponseResult.lines.length > 0) {
        const notepadData = this.getAppointments(notepadsResponseResult.lines);

        // let schedulerDataList = [];
        // this.scheduler.resources[0].dataSource.data(this.resourceData);
        // this.scheduler.view(this.scheduler.view().name);
        notepadData.forEach(dataItem => {
          const schedulerData = {
            id: dataItem.customerNotepadID,
            start: dataItem.followUpDateTime,
            // startTimezone: dataItem.tim,
            end: dataItem.endDateTime,
            // endTimezone: dataItem.endTimezone,
            // isAllDay: dataItem.IsAllDay,
            title: dataItem.subject,
            description: dataItem.eventNote,
            // recurrenceRule: dataItem.RecurrenceRule,
            // recurrenceId: dataItem.RecurrenceID,
            // recurrenceException: dataItem.RecurrenceException,

            // roomId: dataItem.RoomID,
            ownerID: dataItem.userID
          };
          this.eventData.push(schedulerData);
        });

        this.updateschedulerevent();
        this.events = this.eventData;
      }
    });
  }


  updateschedulerevent() {
    const dataSource = new kendo.data.SchedulerDataSource({
      data: this.eventData
    });
    this.scheduler.setDataSource(dataSource);
    kendo.ui.progress(this.scheduler.element.find('.k-scheduler-content'), true);
  }

  getAppointments(notepadsResponseResult: CustomerNotepad[]): CustomerNotepad[] {
    // Get BisTrack User events only
    let results = notepadsResponseResult.filter(item => item.userID == this.webTrackUser.bisTrackUserId || item.followUpByID == this.webTrackUser.bisTrackUserId);
    // Choose appointments and follow-up notepads only
    results = results.filter(item => item.followUpDateTime && item.noteDateTime);
    // Update EndDateTime
    results.forEach(element => {
      element.followUpDateTime = this.getLocalTime(element.followUpDateTime);
      element.noteDateTime = this.getLocalTime(element.noteDateTime);

      element.endDateTime = element.endDateTime ? this.getLocalTime(element.endDateTime) : null;

      if (!element.appointmentNote) {
        // let endDateTime = {
        //   date: element.followUpDateTime,
        // };
        // endDateTime.followUpDateTime = element.followUpDateTime;
        element.endDateTime = new Date(element.followUpDateTime);
        // endDateTime.setMinutes(endDateTime.getMinutes() + 15);

        // element.endDateTime = element.followUpDateTime;
        element.endDateTime.setMinutes(element.endDateTime.getMinutes() + 15);
      }
    });
    // Scheduler raise exception if this condition is not met

    results = results.filter(n => n.endDateTime > n.followUpDateTime);
    return results;
  }

  getLocalTime(x) {
    const hoursDiff = x.getHours() - x.getTimezoneOffset() / 60;
    const minutesDiff = (x.getHours() - x.getTimezoneOffset()) % 60;
    x.setHours(hoursDiff);
    x.setMinutes(minutesDiff);
    return x;
  }
  prepareNotepadRequest(): GetCustomerNotepadItemsRequest {
    const customerNotepadItemsRequest = new GetCustomerNotepadItemsRequest();
    customerNotepadItemsRequest.currentUser = this.webTrackUser;
    customerNotepadItemsRequest.currentUser.customer.customerId = -1;
    customerNotepadItemsRequest.pagingParameters = null;
    customerNotepadItemsRequest.sortParameters = null;
    customerNotepadItemsRequest.searchType = 'CalendarItems';
    customerNotepadItemsRequest.searchContact = 'AllContacts';
    customerNotepadItemsRequest.searchMonths = 'AllDates';
    customerNotepadItemsRequest.searchValue = '';

    return customerNotepadItemsRequest;
  }
}
